export const SET_PROFESSOR_GUIDANCES = 'FACULTY_PROFESSOR/SET_FACULTY_GUIDANCES'
export const SET_PROFESSOR_COGUIDANCES = 'FACULTY_PROFESSOR/SET_FACULTY_COGUIDANCES'
